import PromotionProvider from '@/resources/promotion_provider'
import { getCurrentBranchPOS } from '@/utils/helper/localStorage'
const promotionProvider = new PromotionProvider()

const state = {
  items: [],
  customerTel: '',
  discount: 0,
  promotionCode: {}
}

const actions = {
  async verifyPromoCode ({ commit, dispatch, state }, payload) {
    const res = await promotionProvider.verifyPromotionCode({
      code: payload.promoCode,
      memberTel: payload.tel,
      items: state.items,
      warehouse: {
        id: parseInt(getCurrentBranchPOS().branch_id),
        name: getCurrentBranchPOS().warehouse_display_name,
        code: getCurrentBranchPOS().warehouse
      }
    })
    if (res.data.success) {
      commit('SET_PROMOTION_CODE', res.data.promotion_code)
      commit('SET_DISCOUNT', res.data.discount)
    } else {
      dispatch('clearDiscount')
    }
    return res
  },
  async addItem ({commit}, payload = '') {
    if (payload) {
      commit('ADD_ITEM', payload)
      commit('CLEAR_DISCOUNT')
      return true
    }
    return false
  },
  removeItem ({commit}, payload) {
    commit('REMOVE_ITEM', payload)
    commit('CLEAR_DISCOUNT')
  },
  setTel ({commit}, payload) {
    commit('SET_TEL', payload)
  },
  clearAllData ({dispatch, commit}) {
    this.dispatch('clearMoney')
    this.dispatch('initState')
    dispatch('clearDiscount')
    commit('CLEAR_ITEM_IN_CART')
    dispatch('setTel')
  },
  clearDiscount ({commit}) {
    commit('CLEAR_DISCOUNT')
  }
}

const mutations = {
  ADD_ITEM: (state, payload) => {
    state.items.push(payload)
  },
  SET_PROMOTION_CODE: (state, payload) => {
    state.promotionCode = payload
  },
  SET_DISCOUNT: (state, payload) => {
    state.discount = payload
  },
  CLEAR_ITEM_IN_CART: (state) => {
    state.items = []
  },
  REMOVE_ITEM: (state, payload) => {
    const index = state.items.findIndex(item => item.id === payload.id)
    state.items.splice(index, 1)
  },
  CLEAR_DISCOUNT: (state) => {
    state.discount = 0
    state.promotionCode = {}
  },
  SET_TEL: (state, payload = '') => {
    state.customerTel = payload
  }
}

const getters = {
  getItems: (state) => {
    return state.items
  },
  getFullPrice: (state) => {
    return state.items.reduce((sum, item) => sum + parseInt(item.price), 0)
  },
  getNetPrice: (state) => {
    const netPrice = state.items.reduce((sum, item) => sum + parseInt(item.price), 0) - state.discount
    return (netPrice <= 0) ? 0 : netPrice
  },
  getItemsAmount: (state) => {
    return (state.items.reduce((sum, item) => sum + item.quantity, 0))
  },
  getDiscount: (state) => {
    return state.discount
  },
  discount: state => state.discount,
  getPromotionCode: (state) => state.promotionCode,
  getTel: (state) => {
    return state.customerTel
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js